import { render, staticRenderFns } from "./w-home-nav.vue?vue&type=template&id=4467d2ee&scoped=true&"
import script from "./w-home-nav.vue?vue&type=script&lang=js&"
export * from "./w-home-nav.vue?vue&type=script&lang=js&"
import style0 from "./w-home-nav.vue?vue&type=style&index=0&id=4467d2ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4467d2ee",
  null
  
)

export default component.exports